// if (!customElements.get('product-inventory')) {
//   class ProductInventory extends HTMLElement {
//     constructor() {
//       super();
//       window.initLazyScript(this, this.initLazySection.bind(this));
//     }

//     initLazySection() {
//       this.inventoryNotice = this.querySelector('.js-inventory-notice');
//       this.urgencyMessage = this.querySelector('.js-inventory-urgency');
//       this.indicatorBar = this.querySelector('.js-inventory-indicator');
//       this.variantInventory = this.getVariantInventory();

//       // Bind to on:variant:change event for this product
//       const variantPicker = this.closest('.product-info').querySelector('variant-picker');
//       if (variantPicker) {
//         variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
//       }

//       // Init
//       this.updateInventory(
//         parseInt(this.dataset.inventoryQuantity, 10),
//         this.dataset.variantAvailable === 'true'
//       );

//       // Note: Removed unused moment() call - result was never used
//       var todayDates = new Date().toLocaleString("en-AU", { timeZone: "Australia/Sydney" });

//       var usaTime = new Date().toLocaleString("en-US", { timeZone: "Australia/Sydney" });
//       var now = new Date(usaTime);
//       var deliveryDate = new Date(usaTime);

//       var business_days = 0;
//       var hour_deadline = 10;
//       var todayWeekDay = now.getDay();

//       var usaTime = new Date().toLocaleString("en-US", { timeZone: "Australia/Sydney" });
//       var d = new Date(usaTime);
//       var currentWeekDay = d.getDay();
//       var today_date = d.getDate();
//       var hastime = true;
//       var days = 0;
//       if (currentWeekDay == 6) {
//         days = 2;
//       } else if (currentWeekDay == 0) {
//         days = 1;
//       } else if (currentWeekDay == 5) {
//         if (d.getHours() >= hour_deadline) {
//           days = 3;
//         }
//       } else {
//         if (d.getHours() >= hour_deadline) {
//           days = 1;
//         }
//       }

//       Date.prototype.addDays = function (days) {
//         var usaTime = new Date().toLocaleString("en-US", { timeZone: "Australia/Sydney" });
//         var d = new Date(usaTime);
//         this.setDate(d.getDate() + parseInt(days));
//         return this;
//       };
//       Date.prototype.getWeekDay = function () {
//         var weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
//         return weekday[this.getDay()];
//       }

//       var currentDate = d;
//       var res = currentDate.addDays(days);
//       res = res.getDate();
//       var curr_month = d.getMonth();
//       curr_month++;
//       var curr_year = d.getFullYear();

//       var countDownDate = new Date('' + curr_month + '/' + res + '/' + curr_year + ' ' + '10:00:00');
//       var updatedCountDownDate = countDownDate;

//       var usaTime = new Date().toLocaleString("en-US", { timeZone: "Australia/Sydney" });
//       var now = new Date(usaTime);

//       var distance = updatedCountDownDate - now;
//       var days = Math.floor(distance / (1000 * 60 * 60 * 24));
//       var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//       var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//       var seconds = Math.floor((distance % (1000 * 60)) / 1000);

//       var weekday = new Date(new Date('' + curr_month + '/' + res + '/' + curr_year + ' ')).getWeekDay();
//       var html = "Order within <span class='time-left'>" + (hours + (days * 24)) + " hrs " + minutes + " min</span> to dispatch " + weekday;
//       var shippingTimeEl = document.getElementById('shipping-time');
//       if (shippingTimeEl) shippingTimeEl.innerHTML = html;
//     }

//     /**
//      * Gets the inventory data for all product variants
//      * @returns {?object}
//      */
//     getVariantInventory() {
//       const dataEl = this.querySelector('[type="application/json"]');
//       return this.variantInventory || JSON.parse(dataEl.textContent);
//     }

//     /**
//      * Handles a 'change' event on the variant picker element
//      * @param {object} evt - Event object
//      */
//     handleVariantChange(evt) {
//       if (evt.detail.variant) {
//         const inventory = this.variantInventory.filter(
//           (variant) => variant.id === evt.detail.variant.id
//         )[0];
//         this.updateInventory(inventory.inventory_quantity, inventory.available);
//         this.customUpdateStock(inventory);
//       } else {
//         this.updateInventory(0, false);
//         this.hidden = true;
//       }
//     }

//     /**
//      *
//      * Updates the inventory notice
//      * @param {number} count - the inventory quantity available
//      * @param {boolean} available - whether current variant is available
//      */
//     updateInventory(count, available) {
//       let inventoryLevel;
//       if (count <= 0) {
//         if (available) {
//           inventoryLevel = 'in_stock';
//         } else {
//           inventoryLevel = 'none';
//         }
//       } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
//         inventoryLevel = 'very_low';
//       } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
//         inventoryLevel = 'low';
//       } else {
//         inventoryLevel = 'normal';
//       }

//       if (this.dataset.showNotice === 'always'
//         || (this.dataset.showNotice === 'low' && inventoryLevel.includes('low'))) {
//         this.hidden = false;

//         // Set the inventory level data attribute
//         this.setAttribute('data-inventory-level', inventoryLevel);

//         // Determine whether to show the count or not
//         if (inventoryLevel !== 'in_stock' && (this.dataset.showCount === 'always' || (this.dataset.showCount === 'low' && inventoryLevel.includes('low')))) {
//           if (count > 100) {
//             this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', '100+');
//           } else if (count < 100 && count > 50) {
//             this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', '50+');
//           } else {
//             this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
//           }
//         } else if (inventoryLevel.includes('low')) {
//           this.inventoryNotice.innerText = theme.strings.lowStock;
//         } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
//           this.inventoryNotice.innerText = theme.strings.inStock;
//         } else if (inventoryLevel === 'none') {
//           this.inventoryNotice.innerText = theme.strings.noStock;
//         }

//         // Update urgency message if needed
//         if (this.urgencyMessage) {
//           if (inventoryLevel === 'very_low') {
//             this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
//           } else if (inventoryLevel === 'low') {
//             this.urgencyMessage.innerHTML = this.dataset.textLow;
//           } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
//             this.urgencyMessage.innerHTML = this.dataset.textNormal;
//           } else if (inventoryLevel === 'none') {
//             this.urgencyMessage.innerHTML = this.dataset.textNoStock;
//           }
//         }

//         // Update the bar indicator
//         if (this.indicatorBar) {
//           this.indicatorBar.hidden = false;

//           let newWidth;
//           if (count >= this.dataset.scale || inventoryLevel === 'in_stock') {
//             newWidth = 100;
//           } else {
//             newWidth = ((100 / parseInt(this.dataset.scale, 10)) * count).toFixed(1);
//           }
//           this.indicatorBar.querySelector('span').style.width = `${newWidth}%`;
//         }
//       } else {
//         this.hidden = true;
//       }
//     }

//     customUpdateStock(availableVariants) {
//       var availHTML = "";

//       // Helper functions to replace jQuery
//       function hideCheckoutBtn() {
//         document.querySelectorAll('.dynamic_checkout_btn').forEach(function (el) { el.classList.add('hidden'); });
//       }
//       function showCheckoutBtn() {
//         document.querySelectorAll('.dynamic_checkout_btn').forEach(function (el) { el.classList.remove('hidden'); });
//       }
//       function hideShippingTime() {
//         var shippingEl = document.getElementById('shipping-time');
//         if (shippingEl && shippingEl.parentElement) shippingEl.parentElement.classList.add('hidden');
//       }
//       function showShippingTime() {
//         var shippingEl = document.getElementById('shipping-time');
//         if (shippingEl && shippingEl.parentElement) shippingEl.parentElement.classList.remove('hidden');
//       }

//       if (availableVariants) {
//         if (availableVariants.inventory_management == "shopify") {
//           if (availableVariants.inventory_quantity < 10 && availableVariants.inventory_quantity > 0) {
//             availHTML = " ";
//           } else if (availableVariants.inventory_quantity <= 0 && availableVariants.inventory_policy == "continue") {
//             if (availableVariants.next_incoming_date) {
//               availHTML = "<span>Restocking " + availableVariants.next_incoming_date + "</span>";
//             } else {
//               availHTML = "<span></span>";
//             }
//           } else if (availableVariants.inventory_quantity <= 0 && availableVariants.inventory_policy == "deny") {
//             if (availableVariants.next_incoming_date) {
//               hideCheckoutBtn();
//               hideShippingTime();
//               availHTML = "<span>Restocking " + availableVariants.next_incoming_date + "</span>";
//             } else {
//               console.log('de else');
//               hideShippingTime();
//               availHTML = "<span> </span>";
//             }
//           } else {
//             if (availableVariants.available == false) {
//               hideCheckoutBtn();
//               hideShippingTime();
//             } else {
//               showCheckoutBtn();
//               showShippingTime();
//             }
//           }
//         } else {
//           if (availableVariants.available == false) {
//             availHTML = " ";
//           } else {
//             showCheckoutBtn();
//             availHTML = " ";
//           }
//         }
//       }
//       document.querySelectorAll('.backorder_date .change_content').forEach(function (el) {
//         el.setAttribute('data-max', availableVariants.inventory_quantity);
//         el.innerHTML = availHTML;
//       });
//     }
//   }

//   customElements.define('product-inventory', ProductInventory);
// }

// Dulora: shared across ALL product-inventory instances on a page (main product +
// any recommendation/complementary cards that also render this snippet), so the same
// variant's UK stock is only ever fetched once, not once per card instance.
// window.__dlUkStockCache = window.__dlUkStockCache || {};
// window.__dlUkLocationNamesSeen = window.__dlUkLocationNamesSeen || new Set();

// if (!customElements.get('product-inventory')) {
//   class ProductInventory extends HTMLElement {
//     constructor() {
//       super();
//       window.initLazyScript(this, this.initLazySection.bind(this));
//     }

//     initLazySection() {
//       this.inventoryNotice = this.querySelector('.js-inventory-notice');
//       this.urgencyMessage = this.querySelector('.js-inventory-urgency');
//       this.indicatorBar = this.querySelector('.js-inventory-indicator');
//       this.variantInventory = this.getVariantInventory();

//       // Bind to on:variant:change event for this product
//       const variantPicker = this.closest('.product-info').querySelector('variant-picker');
//       if (variantPicker) {
//         variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
//       }

//       // Init
//       this.updateInventory(
//         parseInt(this.dataset.inventoryQuantity, 10),
//         this.dataset.variantAvailable === 'true'
//       );

//       // Dulora: replaces the old hardcoded Sydney/10am/AEST countdown with a
//       // configurable, DST-safe, per-warehouse implementation. See
//       // initWarehouseDispatch() / renderWarehouseCountdown() below.
//       this.initWarehouseDispatch();
//     }

//     // ------------------------------------------------------------------
//     // Dulora warehouse dispatch: stock tooltip + countdown, configurable by
//     // IANA timezone/cutoff hour, dynamic for UK/EU based on live UK stock.
//     // ------------------------------------------------------------------

//     initWarehouseDispatch() {
//       this._dlDebounceTimer = null;

//       this._dlMode = this.dataset.warehouseMode || 'static';
//       this._dlAuTooltip = this.dataset.auTooltip || 'This product ships from our Sydney, Australia warehouse.';
//       this._dlUkTooltip = this.dataset.ukTooltip || 'This product ships from our UK warehouse.';
//       this._dlAuCutoffHour = parseInt(this.dataset.auCutoffHour, 10) || 10;
//       this._dlAuTimezone = this.dataset.auTimezone || 'Australia/Sydney';
//       this._dlUkCutoffHour = parseInt(this.dataset.ukCutoffHour, 10) || 14;
//       this._dlUkTimezone = this.dataset.ukTimezone || 'Europe/London';
//       this._dlUkLocationName = this.dataset.ukLocationName || 'UK - Warehouse';
//       this._dlTooltipOverridden = this.dataset.tooltipOverridden === 'true';
//       this._dlVariantId = this.dataset.variantId;

//       this._dlTooltipEl = this.querySelector('.js-stock-tooltip-text');
//       // Both possible #shipping-time spans (only one renders per backorder branch at a time).
//       this._dlCountdownEls = () => Array.prototype.slice.call(document.querySelectorAll('.js-shipping-time'));

//       this.evaluateWarehouseDispatch();

//       // Refresh every minute so the countdown stays accurate even with no interaction.
//       clearInterval(this._dlCountdownInterval);
//       this._dlCountdownInterval = setInterval(this.evaluateWarehouseDispatch.bind(this), 60000);

//       if (this._dlMode === 'dynamic') {
//         const qtyInput = document.querySelector('input[name="quantity"], input[data-quantity-input]');
//         if (qtyInput) {
//           const debounced = () => {
//             clearTimeout(this._dlDebounceTimer);
//             this._dlDebounceTimer = setTimeout(this.evaluateWarehouseDispatch.bind(this), 300);
//           };
//           qtyInput.addEventListener('input', debounced);
//           qtyInput.addEventListener('change', debounced);
//         }
//       }
//     }

//     /** Reads the current quantity selector value, defaulting to 1. */
//     getSelectedQuantity() {
//       const qtyInput = document.querySelector('input[name="quantity"], input[data-quantity-input]');
//       const val = qtyInput ? parseInt(qtyInput.value, 10) : 1;
//       return isNaN(val) || val < 1 ? 1 : val;
//     }

//     /**
//      * Fetches UK - Warehouse available stock for a variant via the Storefront API
//      * (storeAvailability). Per-location inventory is not exposed in Liquid — only
//      * variant.inventory_quantity (total across all locations) is — so this is the
//      * only client-safe, no-reload way to read a specific location's stock.
//      * Cached per variant id.
//      */
//     fetchUkWarehouseStock(variantId) {
//       if (window.__dlUkStockCache.hasOwnProperty(variantId)) {
//         return Promise.resolve(window.__dlUkStockCache[variantId]);
//       }

//       const query = `query variantAvailability($id: ID!) {
//         node(id: $id) {
//           ... on ProductVariant {
//             storeAvailability(first: 20) {
//               edges { node { quantityAvailable location { name } } }
//             }
//           }
//         }
//       }`;

//       const gid = 'gid://shopify/ProductVariant/' + variantId;

//       return fetch('/api/2024-10/graphql.json', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'X-Shopify-Storefront-Access-Token': window.DULORA_STOREFRONT_TOKEN || ''
//         },
//         body: JSON.stringify({ query, variables: { id: gid } })
//       })
//         .then((res) => res.json())
//         .then((json) => {
//           if (json.errors) {
//             // GraphQL returns HTTP 200 even when the query itself errors (e.g. a
//             // permissions/scope issue reading storeAvailability). Surface it loudly
//             // instead of silently falling back, since a 200 status alone doesn't mean
//             // the data came back.
//             console.warn('[Dulora warehouse-dispatch] GraphQL errors for variant ' + variantId + ':', json.errors);
//             window.__dlUkStockCache[variantId] = 0;
//             return 0;
//           }

//           const edges = (json && json.data && json.data.node && json.data.node.storeAvailability)
//             ? json.data.node.storeAvailability.edges
//             : [];

//           edges.forEach((e) => {
//             if (e.node.location && e.node.location.name) {
//               window.__dlUkLocationNamesSeen.add(e.node.location.name);
//             }
//           });

//           const ukEdge = edges.find((e) => e.node.location && e.node.location.name === this._dlUkLocationName);

//           if (!ukEdge && edges.length > 0) {
//             // Location names returned by the API but none matched data-uk-location-name.
//             // This is the #1 likely cause if the UK/EU dynamic logic always falls back
//             // to Sydney despite successful API calls — the configured name almost
//             // certainly doesn't exactly match what Shopify has. Logging every location
//             // name actually seen makes this a 5-second fix instead of a guessing game.
//             console.warn(
//               '[Dulora warehouse-dispatch] No location matched "' + this._dlUkLocationName + '" for variant ' + variantId + '.'
//               + ' Locations returned by the API: [' + Array.from(window.__dlUkLocationNamesSeen).join(', ') + ']'
//               + '. Update data-uk-location-name in snippets/product-inventory.liquid to match exactly.'
//             );
//           }

//           const qty = ukEdge ? ukEdge.node.quantityAvailable : 0;
//           window.__dlUkStockCache[variantId] = qty;
//           return qty;
//         })
//         .catch((err) => {
//           console.warn('[Dulora warehouse-dispatch] fetch failed for variant ' + variantId + ':', err);
//           // Fail safe: if UK stock can't be determined, fall back to Sydney copy
//           // rather than incorrectly promising UK dispatch.
//           window.__dlUkStockCache[variantId] = 0;
//           return 0;
//         });
//     }

//     /** Computes ms remaining until the next valid cutoff (Mon-Fri) in a given IANA timezone. */
//     msUntilNextCutoff(timeZone, cutoffHour) {
//       const fmt = new Intl.DateTimeFormat('en-US', {
//         timeZone, hour12: false, year: 'numeric', month: '2-digit', day: '2-digit',
//         hour: '2-digit', minute: '2-digit', second: '2-digit', weekday: 'short'
//       });
//       const map = {};
//       fmt.formatToParts(new Date()).forEach((p) => { map[p.type] = p.value; });

//       const parts = {
//         year: parseInt(map.year, 10),
//         month: parseInt(map.month, 10),
//         day: parseInt(map.day, 10),
//         hour: parseInt(map.hour, 10) === 24 ? 0 : parseInt(map.hour, 10),
//         minute: parseInt(map.minute, 10),
//         second: parseInt(map.second, 10),
//         weekday: map.weekday
//       };

//       const weekdayOrder = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
//       const isWeekend = (w) => w === 'Sat' || w === 'Sun';

//       const localNowMs = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);

//       let daysToAdd = 0;
//       let dispatchToday = false;

//       if (!isWeekend(parts.weekday) && parts.hour < cutoffHour) {
//         dispatchToday = true;
//       } else {
//         daysToAdd = 1;
//         const weekdayIndex = weekdayOrder.indexOf(parts.weekday);
//         let nextIndex = (weekdayIndex + daysToAdd) % 7;
//         while (isWeekend(weekdayOrder[nextIndex])) {
//           daysToAdd += 1;
//           nextIndex = (weekdayIndex + daysToAdd) % 7;
//         }
//       }

//       const targetMs = Date.UTC(parts.year, parts.month - 1, parts.day + daysToAdd, cutoffHour, 0, 0);
//       const msRemaining = targetMs - localNowMs;
//       const dispatchWeekdayName = new Intl.DateTimeFormat('en-US', { weekday: 'long', timeZone: 'UTC' })
//         .format(new Date(targetMs));

//       return { msRemaining, dispatchLabel: dispatchToday ? 'today' : dispatchWeekdayName };
//     }

//     formatCountdown(ms) {
//       if (ms <= 0) return '0 hrs 0 min';
//       const totalMinutes = Math.floor(ms / 60000);
//       return Math.floor(totalMinutes / 60) + ' hrs ' + (totalMinutes % 60) + ' min';
//     }

//     renderWarehouseCountdown(timeZone, cutoffHour) {
//       const result = this.msUntilNextCutoff(timeZone, cutoffHour);
//       const html = "Order within <span class='time-left'>" + this.formatCountdown(result.msRemaining)
//         + "</span> to dispatch " + result.dispatchLabel;
//       this._dlCountdownEls().forEach((el) => { el.innerHTML = html; });
//     }

//     applyAuWarehouse() {
//       if (this._dlTooltipEl && !this._dlTooltipOverridden) {
//         this._dlTooltipEl.textContent = this._dlAuTooltip;
//       }
//       this.renderWarehouseCountdown(this._dlAuTimezone, this._dlAuCutoffHour);
//     }

//     applyUkWarehouse() {
//       if (this._dlTooltipEl && !this._dlTooltipOverridden) {
//         this._dlTooltipEl.textContent = this._dlUkTooltip;
//       }
//       this.renderWarehouseCountdown(this._dlUkTimezone, this._dlUkCutoffHour);
//     }

//     evaluateWarehouseDispatch() {
//       if (this._dlMode === 'static') {
//         this.applyAuWarehouse();
//         return;
//       }

//       // dynamic (UK/EU): compare selected quantity against live UK - Warehouse stock
//       this.fetchUkWarehouseStock(this._dlVariantId).then((ukStock) => {
//         if (this.getSelectedQuantity() <= ukStock) {
//           this.applyUkWarehouse();
//         } else {
//           this.applyAuWarehouse();
//         }
//       });
//     }

//     /**
//      * Gets the inventory data for all product variants
//      * @returns {?object}
//      */
//     getVariantInventory() {
//       const dataEl = this.querySelector('[type="application/json"]');
//       return this.variantInventory || JSON.parse(dataEl.textContent);
//     }

//     /**
//      * Handles a 'change' event on the variant picker element
//      * @param {object} evt - Event object
//      */
//     handleVariantChange(evt) {
//       if (evt.detail.variant) {
//         const inventory = this.variantInventory.filter(
//           (variant) => variant.id === evt.detail.variant.id
//         )[0];
//         this.updateInventory(inventory.inventory_quantity, inventory.available);
//         this.customUpdateStock(inventory);

//         // Dulora: new variant may have different UK - Warehouse stock, re-evaluate.
//         this._dlVariantId = evt.detail.variant.id;
//         this.dataset.variantId = evt.detail.variant.id;
//         this.evaluateWarehouseDispatch();
//       } else {
//         this.updateInventory(0, false);
//         this.hidden = true;
//       }
//     }

//     /**
//      *
//      * Updates the inventory notice
//      * @param {number} count - the inventory quantity available
//      * @param {boolean} available - whether current variant is available
//      */
//     updateInventory(count, available) {
//       let inventoryLevel;
//       if (count <= 0) {
//         if (available) {
//           inventoryLevel = 'in_stock';
//         } else {
//           inventoryLevel = 'none';
//         }
//       } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
//         inventoryLevel = 'very_low';
//       } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
//         inventoryLevel = 'low';
//       } else {
//         inventoryLevel = 'normal';
//       }

//       if (this.dataset.showNotice === 'always'
//         || (this.dataset.showNotice === 'low' && inventoryLevel.includes('low'))) {
//         this.hidden = false;

//         // Set the inventory level data attribute
//         this.setAttribute('data-inventory-level', inventoryLevel);

//         // Determine whether to show the count or not
//         if (inventoryLevel !== 'in_stock' && (this.dataset.showCount === 'always' || (this.dataset.showCount === 'low' && inventoryLevel.includes('low')))) {
//           if (count > 100) {
//             this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', '100+');
//           } else if (count < 100 && count > 50) {
//             this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', '50+');
//           } else {
//             this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
//           }
//         } else if (inventoryLevel.includes('low')) {
//           this.inventoryNotice.innerText = theme.strings.lowStock;
//         } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
//           this.inventoryNotice.innerText = theme.strings.inStock;
//         } else if (inventoryLevel === 'none') {
//           this.inventoryNotice.innerText = theme.strings.noStock;
//         }

//         // Update urgency message if needed
//         if (this.urgencyMessage) {
//           if (inventoryLevel === 'very_low') {
//             this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
//           } else if (inventoryLevel === 'low') {
//             this.urgencyMessage.innerHTML = this.dataset.textLow;
//           } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
//             this.urgencyMessage.innerHTML = this.dataset.textNormal;
//           } else if (inventoryLevel === 'none') {
//             this.urgencyMessage.innerHTML = this.dataset.textNoStock;
//           }
//         }

//         // Update the bar indicator
//         if (this.indicatorBar) {
//           this.indicatorBar.hidden = false;

//           let newWidth;
//           if (count >= this.dataset.scale || inventoryLevel === 'in_stock') {
//             newWidth = 100;
//           } else {
//             newWidth = ((100 / parseInt(this.dataset.scale, 10)) * count).toFixed(1);
//           }
//           this.indicatorBar.querySelector('span').style.width = `${newWidth}%`;
//         }
//       } else {
//         this.hidden = true;
//       }
//     }

//     customUpdateStock(availableVariants) {
//       var availHTML = "";

//       // Helper functions to replace jQuery
//       function hideCheckoutBtn() {
//         document.querySelectorAll('.dynamic_checkout_btn').forEach(function (el) { el.classList.add('hidden'); });
//       }
//       function showCheckoutBtn() {
//         document.querySelectorAll('.dynamic_checkout_btn').forEach(function (el) { el.classList.remove('hidden'); });
//       }
//       function hideShippingTime() {
//         var shippingEl = document.getElementById('shipping-time');
//         if (shippingEl && shippingEl.parentElement) shippingEl.parentElement.classList.add('hidden');
//       }
//       function showShippingTime() {
//         var shippingEl = document.getElementById('shipping-time');
//         if (shippingEl && shippingEl.parentElement) shippingEl.parentElement.classList.remove('hidden');
//       }

//       if (availableVariants) {
//         if (availableVariants.inventory_management == "shopify") {
//           if (availableVariants.inventory_quantity < 10 && availableVariants.inventory_quantity > 0) {
//             availHTML = " ";
//           } else if (availableVariants.inventory_quantity <= 0 && availableVariants.inventory_policy == "continue") {
//             if (availableVariants.next_incoming_date) {
//               availHTML = "<span>Restocking " + availableVariants.next_incoming_date + "</span>";
//             } else {
//               availHTML = "<span></span>";
//             }
//           } else if (availableVariants.inventory_quantity <= 0 && availableVariants.inventory_policy == "deny") {
//             if (availableVariants.next_incoming_date) {
//               hideCheckoutBtn();
//               hideShippingTime();
//               availHTML = "<span>Restocking " + availableVariants.next_incoming_date + "</span>";
//             } else {
//               console.log('de else');
//               hideShippingTime();
//               availHTML = "<span> </span>";
//             }
//           } else {
//             if (availableVariants.available == false) {
//               hideCheckoutBtn();
//               hideShippingTime();
//             } else {
//               showCheckoutBtn();
//               showShippingTime();
//             }
//           }
//         } else {
//           if (availableVariants.available == false) {
//             availHTML = " ";
//           } else {
//             showCheckoutBtn();
//             availHTML = " ";
//           }
//         }
//       }
//       document.querySelectorAll('.backorder_date .change_content').forEach(function (el) {
//         el.setAttribute('data-max', availableVariants.inventory_quantity);
//         el.innerHTML = availHTML;
//       });
//     }
//   }

//   customElements.define('product-inventory', ProductInventory);
// }


// // Dulora: shared across ALL product-inventory instances on a page
// window.__dlUkStockCache = window.__dlUkStockCache || {};
// window.__dlUkLocationNamesSeen = window.__dlUkLocationNamesSeen || new Set();

// if (!customElements.get('product-inventory')) {
//   class ProductInventory extends HTMLElement {
//     constructor() {
//       super();
//       window.initLazyScript(this, this.initLazySection.bind(this));
//     }

//     initLazySection() {
//       this.inventoryNotice = this.querySelector('.js-inventory-notice');
//       this.urgencyMessage = this.querySelector('.js-inventory-urgency');
//       this.indicatorBar = this.querySelector('.js-inventory-indicator');
//       this.variantInventory = this.getVariantInventory();

//       const variantPicker = this.closest('.product-info')?.querySelector('variant-picker');
//       if (variantPicker) {
//         variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
//       }

//       this.updateInventory(
//         parseInt(this.dataset.inventoryQuantity, 10),
//         this.dataset.variantAvailable === 'true'
//       );

//       this.initWarehouseDispatch();
//     }

//     initWarehouseDispatch() {
//       this._dlDebounceTimer = null;

//       this._dlMode = this.dataset.warehouseMode || 'static';
//       this._dlAuTooltip = this.dataset.auTooltip || 'This product ships from our Sydney, Australia warehouse.';
//       this._dlUkTooltip = this.dataset.ukTooltip || 'This product ships from our UK warehouse.';
//       this._dlAuCutoffHour = parseInt(this.dataset.auCutoffHour, 10) || 10;
//       this._dlAuTimezone = this.dataset.auTimezone || 'Australia/Sydney';
//       this._dlUkCutoffHour = parseInt(this.dataset.ukCutoffHour, 10) || 14;
//       this._dlUkTimezone = this.dataset.ukTimezone || 'Europe/London';
//       this._dlUkLocationName = this.dataset.ukLocationName || 'UK - Warehouse';
//       this._dlTooltipOverridden = this.dataset.tooltipOverridden === 'true';
//       this._dlVariantId = this.dataset.variantId;

//       this._dlTooltipEl = this.querySelector('.js-stock-tooltip-text');
//       this._dlCountdownEls = () => Array.from(document.querySelectorAll('.js-shipping-time'));

//       this.evaluateWarehouseDispatch();

//       clearInterval(this._dlCountdownInterval);
//       this._dlCountdownInterval = setInterval(this.evaluateWarehouseDispatch.bind(this), 60000);

//       if (this._dlMode === 'dynamic') {
//         const qtyInput = document.querySelector('input[name="quantity"], input[data-quantity-input]');
//         if (qtyInput) {
//           const debounced = () => {
//             clearTimeout(this._dlDebounceTimer);
//             this._dlDebounceTimer = setTimeout(this.evaluateWarehouseDispatch.bind(this), 300);
//           };
//           qtyInput.addEventListener('input', debounced);
//           qtyInput.addEventListener('change', debounced);
//         }
//       }
//     }

//     getSelectedQuantity() {
//       const qtyInput = document.querySelector('input[name="quantity"], input[data-quantity-input]');
//       const val = qtyInput ? parseInt(qtyInput.value, 10) : 1;
//       return isNaN(val) || val < 1 ? 1 : val;
//     }

//     fetchUkWarehouseStock(variantId) {
//       if (window.__dlUkStockCache.hasOwnProperty(variantId)) {
//         return Promise.resolve(window.__dlUkStockCache[variantId]);
//       }

//       const query = `query variantAvailability($id: ID!) {
//         node(id: $id) {
//           ... on ProductVariant {
//             storeAvailability(first: 20) {
//               edges { node { quantityAvailable location { name } } }
//             }
//           }
//         }
//       }`;

//       const gid = 'gid://shopify/ProductVariant/' + variantId;
//       const storefrontToken = window.DULORA_STOREFRONT_TOKEN || '';

//       const headers = {
//         'Content-Type': 'application/json'
//       };

//       if (storefrontToken) {
//         headers['X-Shopify-Storefront-Access-Token'] = storefrontToken;
//       }

//       return fetch('/api/2024-10/graphql.json', {
//         method: 'POST',
//         headers: headers,
//         body: JSON.stringify({ query, variables: { id: gid } })
//       })
//         .then((res) => {
//           if (!res.ok) {
//             throw new Error(`Storefront API HTTP error: ${res.status}`);
//           }
//           return res.json();
//         })
//         .then((json) => {
//           if (json.errors) {
//             console.warn('[Dulora warehouse-dispatch] GraphQL errors for variant ' + variantId + ':', json.errors);
//             window.__dlUkStockCache[variantId] = 0;
//             return 0;
//           }

//           const edges = json?.data?.node?.storeAvailability?.edges || [];

//           edges.forEach((e) => {
//             if (e.node.location?.name) {
//               window.__dlUkLocationNamesSeen.add(e.node.location.name);
//             }
//           });

//           const ukEdge = edges.find((e) => {
//             const name = e.node.location?.name || '';
//             return name.toLowerCase().includes('uk') || name === this._dlUkLocationName;
//           });

//           const qty = ukEdge ? ukEdge.node.quantityAvailable : 0;
//           window.__dlUkStockCache[variantId] = qty;
//           return qty;
//         })
//         .catch((err) => {
//           console.warn('[Dulora warehouse-dispatch] Fetch failed for variant ' + variantId + ':', err);
//           window.__dlUkStockCache[variantId] = 0;
//           return 0;
//         });
//     }

//     msUntilNextCutoff(timeZone, cutoffHour) {
//       const now = new Date();

//       const fmt = new Intl.DateTimeFormat('en-US', {
//         timeZone,
//         hour12: false,
//         year: 'numeric',
//         month: 'numeric',
//         day: 'numeric',
//         hour: 'numeric',
//         minute: 'numeric',
//         second: 'numeric',
//         weekday: 'short'
//       });

//       const parts = {};
//       fmt.formatToParts(now).forEach((p) => { parts[p.type] = p.value; });

//       const year = parseInt(parts.year, 10);
//       const month = parseInt(parts.month, 10);
//       const day = parseInt(parts.day, 10);
//       let hour = parseInt(parts.hour, 10);
//       if (hour === 24) hour = 0;
//       const weekday = parts.weekday;

//       const isWeekend = weekday === 'Sat' || weekday === 'Sun';

//       let daysToAdd = 0;
//       let dispatchToday = false;

//       if (!isWeekend && hour < cutoffHour) {
//         dispatchToday = true;
//         daysToAdd = 0;
//       } else {
//         const weekdayOrder = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
//         let curIdx = weekdayOrder.indexOf(weekday);
//         daysToAdd = 1;
//         let nextIdx = (curIdx + daysToAdd) % 7;

//         while (weekdayOrder[nextIdx] === 'Sat' || weekdayOrder[nextIdx] === 'Sun') {
//           daysToAdd++;
//           nextIdx = (curIdx + daysToAdd) % 7;
//         }
//       }

//       const targetDateParts = new Date(Date.UTC(year, month - 1, day + daysToAdd, cutoffHour, 0, 0));
//       const targetYear = targetDateParts.getUTCFullYear();
//       const targetMonth = targetDateParts.getUTCMonth();
//       const targetDay = targetDateParts.getUTCDate();

//       const targetInTz = new Date(new Date().toLocaleString('en-US', { timeZone }));
//       const nowInTz = new Date(new Date().toLocaleString('en-US', { timeZone }));

//       targetInTz.setFullYear(targetYear, targetMonth, targetDay);
//       targetInTz.setHours(cutoffHour, 0, 0, 0);

//       const msRemaining = targetInTz.getTime() - nowInTz.getTime();

//       const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
//       const dispatchDayName = dayNames[targetInTz.getDay()];

//       return {
//         msRemaining: Math.max(0, msRemaining),
//         dispatchLabel: dispatchToday ? 'today' : dispatchDayName
//       };
//     }

//     formatCountdown(ms) {
//       if (ms <= 0) return '0 hrs 0 min';
//       const totalMinutes = Math.floor(ms / 60000);
//       const hours = Math.floor(totalMinutes / 60);
//       const minutes = totalMinutes % 60;
//       return `${hours} hrs ${minutes} min`;
//     }

//     renderWarehouseCountdown(timeZone, cutoffHour) {
//       const result = this.msUntilNextCutoff(timeZone, cutoffHour);
//       const html = `Order within <span class='time-left'>${this.formatCountdown(result.msRemaining)}</span> to dispatch ${result.dispatchLabel}`;
//       this._dlCountdownEls().forEach((el) => { el.innerHTML = html; });
//     }

//     applyAuWarehouse() {
//       if (this._dlTooltipEl && !this._dlTooltipOverridden) {
//         this._dlTooltipEl.textContent = this._dlAuTooltip;
//       }
//       this.renderWarehouseCountdown(this._dlAuTimezone, this._dlAuCutoffHour);
//     }

//     applyUkWarehouse() {
//       if (this._dlTooltipEl && !this._dlTooltipOverridden) {
//         this._dlTooltipEl.textContent = this._dlUkTooltip;
//       }
//       this.renderWarehouseCountdown(this._dlUkTimezone, this._dlUkCutoffHour);
//     }

//     evaluateWarehouseDispatch() {
//       if (this._dlMode === 'static') {
//         this.applyAuWarehouse();
//         return;
//       }

//       this.fetchUkWarehouseStock(this._dlVariantId).then((ukStock) => {
//         if (this.getSelectedQuantity() <= ukStock && ukStock > 0) {
//           this.applyUkWarehouse();
//         } else {
//           this.applyAuWarehouse();
//         }
//       });
//     }

//     getVariantInventory() {
//       const dataEl = this.querySelector('[type="application/json"]');
//       return this.variantInventory || JSON.parse(dataEl.textContent);
//     }

//     handleVariantChange(evt) {
//       if (evt.detail.variant) {
//         const inventory = this.variantInventory.find((v) => v.id === evt.detail.variant.id);
//         if (inventory) {
//           this.updateInventory(inventory.inventory_quantity, inventory.available);
//           this.customUpdateStock(inventory);
//         }

//         this._dlVariantId = evt.detail.variant.id;
//         this.dataset.variantId = evt.detail.variant.id;
//         this.evaluateWarehouseDispatch();
//       } else {
//         this.updateInventory(0, false);
//         this.hidden = true;
//       }
//     }

//     updateInventory(count, available) {
//       let inventoryLevel;
//       if (count <= 0) {
//         inventoryLevel = available ? 'in_stock' : 'none';
//       } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
//         inventoryLevel = 'very_low';
//       } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
//         inventoryLevel = 'low';
//       } else {
//         inventoryLevel = 'normal';
//       }

//       if (this.dataset.showNotice === 'always' || (this.dataset.showNotice === 'low' && inventoryLevel.includes('low'))) {
//         this.hidden = false;
//         this.setAttribute('data-inventory-level', inventoryLevel);

//         if (inventoryLevel !== 'in_stock' && (this.dataset.showCount === 'always' || (this.dataset.showCount === 'low' && inventoryLevel.includes('low')))) {
//           if (count > 100) {
//             this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', '100+');
//           } else if (count > 50) {
//             this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', '50+');
//           } else {
//             this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
//           }
//         } else if (inventoryLevel.includes('low')) {
//           this.inventoryNotice.innerText = theme.strings.lowStock;
//         } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
//           this.inventoryNotice.innerText = theme.strings.inStock;
//         } else if (inventoryLevel === 'none') {
//           this.inventoryNotice.innerText = theme.strings.noStock;
//         }

//         if (this.urgencyMessage) {
//           if (inventoryLevel === 'very_low') this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
//           else if (inventoryLevel === 'low') this.urgencyMessage.innerHTML = this.dataset.textLow;
//           else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') this.urgencyMessage.innerHTML = this.dataset.textNormal;
//           else if (inventoryLevel === 'none') this.urgencyMessage.innerHTML = this.dataset.textNoStock;
//         }

//         if (this.indicatorBar) {
//           this.indicatorBar.hidden = false;
//           let newWidth = (count >= this.dataset.scale || inventoryLevel === 'in_stock') ? 100 : ((100 / parseInt(this.dataset.scale, 10)) * count).toFixed(1);
//           this.indicatorBar.querySelector('span').style.width = `${newWidth}%`;
//         }
//       } else {
//         this.hidden = true;
//       }
//     }

//     customUpdateStock(availableVariants) {
//       let availHTML = "";

//       const hideCheckoutBtn = () => document.querySelectorAll('.dynamic_checkout_btn').forEach(el => el.classList.add('hidden'));
//       const showCheckoutBtn = () => document.querySelectorAll('.dynamic_checkout_btn').forEach(el => el.classList.remove('hidden'));
//       const hideShippingTime = () => {
//         const shippingEl = document.getElementById('shipping-time');
//         if (shippingEl?.parentElement) shippingEl.parentElement.classList.add('hidden');
//       };
//       const showShippingTime = () => {
//         const shippingEl = document.getElementById('shipping-time');
//         if (shippingEl?.parentElement) shippingEl.parentElement.classList.remove('hidden');
//       };

//       if (availableVariants) {
//         if (availableVariants.inventory_management === "shopify") {
//           if (availableVariants.inventory_quantity < 10 && availableVariants.inventory_quantity > 0) {
//             availHTML = " ";
//           } else if (availableVariants.inventory_quantity <= 0 && availableVariants.inventory_policy === "continue") {
//             availHTML = availableVariants.next_incoming_date ? `<span>Restocking ${availableVariants.next_incoming_date}</span>` : "<span></span>";
//           } else if (availableVariants.inventory_quantity <= 0 && availableVariants.inventory_policy === "deny") {
//             hideShippingTime();
//             if (availableVariants.next_incoming_date) {
//               hideCheckoutBtn();
//               availHTML = `<span>Restocking ${availableVariants.next_incoming_date}</span>`;
//             } else {
//               availHTML = "<span> </span>";
//             }
//           } else {
//             if (availableVariants.available === false) {
//               hideCheckoutBtn();
//               hideShippingTime();
//             } else {
//               showCheckoutBtn();
//               showShippingTime();
//             }
//           }
//         } else {
//           if (availableVariants.available === false) {
//             availHTML = " ";
//           } else {
//             showCheckoutBtn();
//             availHTML = " ";
//           }
//         }
//       }
//       document.querySelectorAll('.backorder_date .change_content').forEach(el => {
//         el.setAttribute('data-max', availableVariants.inventory_quantity);
//         el.innerHTML = availHTML;
//       });
//     }
//   }

//   customElements.define('product-inventory', ProductInventory);
// }



// window.__dlUkStockCache = window.__dlUkStockCache || {};

// if (!customElements.get('product-inventory')) {
//   class ProductInventory extends HTMLElement {
//     constructor() {
//       super();
//       if (typeof window.initLazyScript === 'function') {
//         window.initLazyScript(this, this.initLazySection.bind(this));
//       } else {
//         this.initLazySection();
//       }
//     }

//     initLazySection() {
//       this.inventoryNotice = this.querySelector('.js-inventory-notice');
//       this.urgencyMessage = this.querySelector('.js-inventory-urgency');
//       this.indicatorBar = this.querySelector('.js-inventory-indicator');
//       this.variantInventory = this.getVariantInventory();

//       const variantPicker = this.closest('.product-info')?.querySelector('variant-picker');
//       if (variantPicker) {
//         variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
//       }

//       this.updateInventory(
//         parseInt(this.dataset.inventoryQuantity, 10) || 0,
//         this.dataset.variantAvailable === 'true'
//       );

//       this.initWarehouseDispatch();
//     }

//     initWarehouseDispatch() {
//       this._dlDebounceTimer = null;

//       this._dlMode = this.dataset.warehouseMode || 'static';
//       this._dlAuTooltip = this.dataset.auTooltip || 'This product ships from our Sydney, Australia warehouse.';
//       this._dlUkTooltip = this.dataset.ukTooltip || 'This product ships from our UK warehouse.';
//       this._dlAuCutoffHour = parseInt(this.dataset.auCutoffHour, 10) || 10;
//       this._dlAuTimezone = this.dataset.auTimezone || 'Australia/Sydney';
//       this._dlUkCutoffHour = parseInt(this.dataset.ukCutoffHour, 10) || 14;
//       this._dlUkTimezone = this.dataset.ukTimezone || 'Europe/London';
//       this._dlUkLocationName = this.dataset.ukLocationName || 'UK - Warehouse';
//       this._dlTooltipOverridden = this.dataset.tooltipOverridden === 'true';
//       this._dlVariantId = this.dataset.variantId;

//       this._dlTooltipEl = this.querySelector('.js-stock-tooltip-text');
//       this._dlCountdownEls = () => Array.from(document.querySelectorAll('.js-shipping-time'));

//       this.evaluateWarehouseDispatch();

//       clearInterval(this._dlCountdownInterval);
//       this._dlCountdownInterval = setInterval(this.evaluateWarehouseDispatch.bind(this), 60000);

//       if (this._dlMode === 'dynamic') {
//         const qtyInput = document.querySelector('input[name="quantity"], input[data-quantity-input]');
//         if (qtyInput) {
//           const debounced = () => {
//             clearTimeout(this._dlDebounceTimer);
//             this._dlDebounceTimer = setTimeout(this.evaluateWarehouseDispatch.bind(this), 300);
//           };
//           qtyInput.addEventListener('input', debounced);
//           qtyInput.addEventListener('change', debounced);
//         }
//       }
//     }

//     getSelectedQuantity() {
//       const qtyInput = document.querySelector('input[name="quantity"], input[data-quantity-input]');
//       const val = qtyInput ? parseInt(qtyInput.value, 10) : 1;
//       return isNaN(val) || val < 1 ? 1 : val;
//     }

//     fetchUkWarehouseStock(variantId) {
//       if (window.__dlUkStockCache.hasOwnProperty(variantId)) {
//         return Promise.resolve(window.__dlUkStockCache[variantId]);
//       }

//       const query = `query variantAvailability($ids: [ID!]!) {
//         nodes(ids: $ids) {
//           ... on ProductVariant {
//             storeAvailability(first: 20) {
//               edges { node { quantityAvailable location { name } } }
//             }
//           }
//         }
//       }`;

//       const gid = 'gid://shopify/ProductVariant/' + variantId;
//       const storefrontToken = (window.DULORA_STOREFRONT_TOKEN || '').replace(/[^\x00-\x7F]/g, '').trim();

//       const headers = { 'Content-Type': 'application/json' };
//       if (storefrontToken) {
//         headers['X-Shopify-Storefront-Access-Token'] = storefrontToken;
//       }

//       return fetch('/api/2024-10/graphql.json', {
//         method: 'POST',
//         headers: headers,
//         body: JSON.stringify({ query, variables: { ids: [gid] } })
//       })
//         .then((res) => {
//           if (!res.ok) throw new Error(`HTTP ${res.status}`);
//           return res.json();
//         })
//         .then((json) => {
//           const edges = json?.data?.nodes?.[0]?.storeAvailability?.edges || [];
//           const ukEdge = edges.find((e) => {
//             const name = (e.node.location?.name || '').toLowerCase();
//             return name.includes('uk') || name === this._dlUkLocationName.toLowerCase();
//           });

//           const qty = ukEdge ? ukEdge.node.quantityAvailable : 0;
//           window.__dlUkStockCache[variantId] = qty;
//           return qty;
//         })
//         .catch((err) => {
//           console.warn('[Dulora Warehouse] Fetch stock failed:', err);
//           window.__dlUkStockCache[variantId] = 0;
//           return 0;
//         });
//     }

//     msUntilNextCutoff(timeZone, cutoffHour) {
//       const now = new Date();
//       const fmt = new Intl.DateTimeFormat('en-US', {
//         timeZone,
//         hour12: false,
//         year: 'numeric',
//         month: 'numeric',
//         day: 'numeric',
//         hour: 'numeric',
//         minute: 'numeric',
//         second: 'numeric',
//         weekday: 'short'
//       });

//       const parts = {};
//       fmt.formatToParts(now).forEach((p) => { parts[p.type] = p.value; });

//       let hour = parseInt(parts.hour, 10);
//       if (hour === 24) hour = 0;
//       const minute = parseInt(parts.minute, 10);
//       const second = parseInt(parts.second, 10);
//       const weekday = parts.weekday;

//       const isWeekend = weekday === 'Sat' || weekday === 'Sun';
//       let daysToAdd = 0;
//       let dispatchToday = false;

//       if (!isWeekend && hour < cutoffHour) {
//         dispatchToday = true;
//         daysToAdd = 0;
//       } else {
//         const weekdayOrder = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
//         let curIdx = weekdayOrder.indexOf(weekday);
//         daysToAdd = 1;
//         let nextIdx = (curIdx + daysToAdd) % 7;

//         while (weekdayOrder[nextIdx] === 'Sat' || weekdayOrder[nextIdx] === 'Sun') {
//           daysToAdd++;
//           nextIdx = (curIdx + daysToAdd) % 7;
//         }
//       }

//       const msRemaining = (daysToAdd * 86400000) +
//         ((cutoffHour - hour - 1) * 3600000) +
//         ((59 - minute) * 60000) +
//         ((60 - second) * 1000);

//       const targetDayIndex = (['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(weekday) + daysToAdd) % 7;
//       const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

//       return {
//         msRemaining: Math.max(0, msRemaining),
//         dispatchLabel: dispatchToday ? 'today' : dayNames[targetDayIndex]
//       };
//     }

//     formatCountdown(ms) {
//       if (ms <= 0) return '0 hrs 0 min';
//       const totalMinutes = Math.floor(ms / 60000);
//       const hours = Math.floor(totalMinutes / 60);
//       const minutes = totalMinutes % 60;
//       return `${hours} hrs ${minutes} min`;
//     }

//     renderWarehouseCountdown(timeZone, cutoffHour) {
//       const result = this.msUntilNextCutoff(timeZone, cutoffHour);
//       const html = `Order within <span class='time-left'>${this.formatCountdown(result.msRemaining)}</span> to dispatch ${result.dispatchLabel}`;
//       this._dlCountdownEls().forEach((el) => { el.innerHTML = html; });
//     }

//     applyAuWarehouse() {
//       if (this._dlTooltipEl && !this._dlTooltipOverridden) {
//         this._dlTooltipEl.textContent = this._dlAuTooltip;
//       }
//       this.renderWarehouseCountdown(this._dlAuTimezone, this._dlAuCutoffHour);
//     }

//     applyUkWarehouse() {
//       if (this._dlTooltipEl && !this._dlTooltipOverridden) {
//         this._dlTooltipEl.textContent = this._dlUkTooltip;
//       }
//       this.renderWarehouseCountdown(this._dlUkTimezone, this._dlUkCutoffHour);
//     }

//     evaluateWarehouseDispatch() {
//       if (this._dlMode === 'static') {
//         this.applyAuWarehouse();
//         return;
//       }

//       this.fetchUkWarehouseStock(this._dlVariantId).then((ukStock) => {
//         if (this.getSelectedQuantity() <= ukStock && ukStock > 0) {
//           this.applyUkWarehouse();
//         } else {
//           this.applyAuWarehouse();
//         }
//       });
//     }

//     getVariantInventory() {
//       const dataEl = this.querySelector('[type="application/json"]');
//       return this.variantInventory || (dataEl ? JSON.parse(dataEl.textContent) : []);
//     }

//     handleVariantChange(evt) {
//       if (evt.detail.variant) {
//         const inventory = this.variantInventory.find((v) => v.id === evt.detail.variant.id);
//         if (inventory) {
//           this.updateInventory(inventory.inventory_quantity, inventory.available);
//           this.customUpdateStock(inventory);
//         }

//         this._dlVariantId = evt.detail.variant.id;
//         this.dataset.variantId = evt.detail.variant.id;
//         this.evaluateWarehouseDispatch();
//       } else {
//         this.updateInventory(0, false);
//         this.hidden = true;
//       }
//     }

//     updateInventory(count, available) {
//       let inventoryLevel;
//       if (count <= 0) {
//         inventoryLevel = available ? 'in_stock' : 'none';
//       } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
//         inventoryLevel = 'very_low';
//       } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
//         inventoryLevel = 'low';
//       } else {
//         inventoryLevel = 'normal';
//       }

//       if (this.dataset.showNotice === 'always' || (this.dataset.showNotice === 'low' && inventoryLevel.includes('low'))) {
//         this.hidden = false;
//         this.setAttribute('data-inventory-level', inventoryLevel);

//         if (inventoryLevel !== 'in_stock' && (this.dataset.showCount === 'always' || (this.dataset.showCount === 'low' && inventoryLevel.includes('low')))) {
//           if (count > 100) {
//             this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', '100+');
//           } else if (count > 50) {
//             this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', '50+');
//           } else {
//             this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
//           }
//         } else if (inventoryLevel.includes('low')) {
//           this.inventoryNotice.innerText = theme.strings.lowStock;
//         } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
//           this.inventoryNotice.innerText = theme.strings.inStock;
//         } else if (inventoryLevel === 'none') {
//           this.inventoryNotice.innerText = theme.strings.noStock;
//         }

//         if (this.urgencyMessage) {
//           if (inventoryLevel === 'very_low') this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
//           else if (inventoryLevel === 'low') this.urgencyMessage.innerHTML = this.dataset.textLow;
//           else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') this.urgencyMessage.innerHTML = this.dataset.textNormal;
//           else if (inventoryLevel === 'none') this.urgencyMessage.innerHTML = this.dataset.textNoStock;
//         }

//         if (this.indicatorBar) {
//           this.indicatorBar.hidden = false;
//           let newWidth = (count >= this.dataset.scale || inventoryLevel === 'in_stock') ? 100 : ((100 / parseInt(this.dataset.scale, 10)) * count).toFixed(1);
//           this.indicatorBar.querySelector('span').style.width = `${newWidth}%`;
//         }
//       } else {
//         this.hidden = true;
//       }
//     }

//     customUpdateStock(availableVariants) {
//       let availHTML = "";

//       const hideCheckoutBtn = () => document.querySelectorAll('.dynamic_checkout_btn').forEach(el => el.classList.add('hidden'));
//       const showCheckoutBtn = () => document.querySelectorAll('.dynamic_checkout_btn').forEach(el => el.classList.remove('hidden'));
//       const hideShippingTime = () => {
//         const shippingEl = document.getElementById('shipping-time');
//         if (shippingEl?.parentElement) shippingEl.parentElement.classList.add('hidden');
//       };
//       const showShippingTime = () => {
//         const shippingEl = document.getElementById('shipping-time');
//         if (shippingEl?.parentElement) shippingEl.parentElement.classList.remove('hidden');
//       };

//       if (availableVariants) {
//         if (availableVariants.inventory_management === "shopify") {
//           if (availableVariants.inventory_quantity < 10 && availableVariants.inventory_quantity > 0) {
//             availHTML = " ";
//           } else if (availableVariants.inventory_quantity <= 0 && availableVariants.inventory_policy === "continue") {
//             availHTML = availableVariants.next_incoming_date ? `<span>Restocking ${availableVariants.next_incoming_date}</span>` : "<span></span>";
//           } else if (availableVariants.inventory_quantity <= 0 && availableVariants.inventory_policy === "deny") {
//             hideShippingTime();
//             if (availableVariants.next_incoming_date) {
//               hideCheckoutBtn();
//               availHTML = `<span>Restocking ${availableVariants.next_incoming_date}</span>`;
//             } else {
//               availHTML = "<span> </span>";
//             }
//           } else {
//             if (availableVariants.available === false) {
//               hideCheckoutBtn();
//               hideShippingTime();
//             } else {
//               showCheckoutBtn();
//               showShippingTime();
//             }
//           }
//         } else {
//           if (availableVariants.available === false) {
//             availHTML = " ";
//           } else {
//             showCheckoutBtn();
//             availHTML = " ";
//           }
//         }
//       }
//       document.querySelectorAll('.backorder_date .change_content').forEach(el => {
//         el.setAttribute('data-max', availableVariants.inventory_quantity);
//         el.innerHTML = availHTML;
//       });
//     }
//   }

//   customElements.define('product-inventory', ProductInventory);
// }



/**
 * Dulora Product Inventory / Warehouse Dispatch
 *
 * Warehouse rules:
 *
 * dulora.com.au
 *   -> Sydney warehouse
 *   -> 10:00 AM Australia/Sydney, Mon-Fri
 *
 * dulora.co.nz
 *   -> Sydney, Australia warehouse
 *   -> 10:00 AM Australia/Sydney, Mon-Fri
 *
 * dulora.com
 *   -> Sydney, Australia warehouse
 *   -> 10:00 AM Australia/Sydney, Mon-Fri
 *
 * dulora.co.uk
 *   -> Dynamic:
 *      quantity <= UK - Warehouse stock
 *        -> UK warehouse
 *        -> 2:00 PM Europe/London, Mon-Fri
 *
 *      quantity > UK - Warehouse stock
 *        -> Sydney warehouse
 *        -> 10:00 AM Australia/Sydney, Mon-Fri
 *
 * dulora.com/en-eu
 *   -> Same dynamic UK/EU behaviour as dulora.co.uk
 */

window.__dlUkStockCache = window.__dlUkStockCache || {};

if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();

      this._dlDebounceTimer = null;
      this._dlCountdownInterval = null;
      this._dlWarehouseRequestId = 0;
      this._dlQuantityInput = null;
      this._dlQuantityListeners = [];
      this._dlMutationObserver = null;

      if (typeof window.initLazyScript === 'function') {
        window.initLazyScript(this, this.initLazySection.bind(this));
      } else {
        this.initLazySection();
      }
    }

    /* ============================================================
       INITIALIZATION
    ============================================================ */

    initLazySection() {
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.urgencyMessage = this.querySelector('.js-inventory-urgency');
      this.indicatorBar = this.querySelector('.js-inventory-indicator');
      this.variantInventory = this.getVariantInventory();

      const variantPicker = this
        .closest('.product-info')
        ?.querySelector('variant-picker');

      if (variantPicker) {
        variantPicker.addEventListener(
          'on:variant:change',
          this.handleVariantChange.bind(this)
        );
      }

      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10) || 0,
        this.dataset.variantAvailable === 'true'
      );

      this.initWarehouseDispatch();
    }

    /* ============================================================
       WAREHOUSE CONFIGURATION
    ============================================================ */

    initWarehouseDispatch() {
      this._dlMode =
        this.dataset.warehouseMode || 'static';

      this._dlAuTooltip =
        this.dataset.auTooltip ||
        'This product ships from our Sydney, Australia warehouse.';

      this._dlUkTooltip =
        this.dataset.ukTooltip ||
        'This product ships from our UK warehouse.';

      this._dlAuCutoffHour =
        parseInt(this.dataset.auCutoffHour, 10) || 10;

      this._dlAuTimezone =
        this.dataset.auTimezone ||
        'Australia/Sydney';

      this._dlUkCutoffHour =
        parseInt(this.dataset.ukCutoffHour, 10) || 14;

      this._dlUkTimezone =
        this.dataset.ukTimezone ||
        'Europe/London';

      this._dlUkLocationName =
        this.dataset.ukLocationName ||
        'UK - Warehouse';

      this._dlTooltipOverridden =
        this.dataset.tooltipOverridden === 'true';

      this._dlVariantId =
        this.dataset.variantId;

      this._dlTooltipEl =
        this.querySelector('.js-stock-tooltip-text');

      this._dlCountdownEls = () =>
        Array.from(
          document.querySelectorAll('.js-shipping-time')
        );

      /*
       * Static storefronts:
       *
       * .com
       * .com.au
       * .co.nz
       *
       * These never request UK inventory.
       */
      if (this._dlMode === 'static') {
        this.applyAuWarehouse();

        this.startCountdownTimer();

        return;
      }

      /*
       * Dynamic storefronts:
       *
       * .co.uk
       * .com/en-eu
       */
      this.setupQuantityListener();

      this.evaluateWarehouseDispatch();

      this.startCountdownTimer();
    }

    /* ============================================================
       COUNTDOWN TIMER
    ============================================================ */

    startCountdownTimer() {
      clearInterval(this._dlCountdownInterval);

      this._dlCountdownInterval = setInterval(() => {
        this.evaluateWarehouseDispatch();
      }, 60000);
    }

    /* ============================================================
       QUANTITY
    ============================================================ */

    getQuantityInput() {
      /*
       * Prefer the quantity input associated with this product.
       */
      const scopedInput =
        this.closest('form')?.querySelector(
          'input[name="quantity"], input[data-quantity-input]'
        );

      if (scopedInput) {
        return scopedInput;
      }

      /*
       * Fallback for themes where the quantity selector
       * is outside the product form.
       */
      return document.querySelector(
        'input[name="quantity"], input[data-quantity-input]'
      );
    }

    getSelectedQuantity() {
      const qtyInput = this.getQuantityInput();

      if (!qtyInput) {
        return 1;
      }

      const value =
        parseInt(qtyInput.value, 10);

      if (Number.isNaN(value) || value < 1) {
        return 1;
      }

      return value;
    }

    setupQuantityListener() {
      const bindQuantityInput = () => {
        const input = this.getQuantityInput();

        if (!input) {
          return;
        }

        /*
         * Don't bind the same input more than once.
         */
        if (this._dlQuantityInput === input) {
          return;
        }

        /*
         * Remove listeners from previous input.
         */
        this.removeQuantityListeners();

        this._dlQuantityInput = input;

        const onQuantityChange = () => {
          clearTimeout(this._dlDebounceTimer);

          this._dlDebounceTimer = setTimeout(() => {
            console.log(
              '[Dulora Warehouse] Quantity changed:',
              this.getSelectedQuantity()
            );

            this.evaluateWarehouseDispatch({
              forceRefresh: false
            });
          }, 300);
        };

        input.addEventListener(
          'input',
          onQuantityChange
        );

        input.addEventListener(
          'change',
          onQuantityChange
        );

        this._dlQuantityListeners = [
          {
            element: input,
            event: 'input',
            handler: onQuantityChange
          },
          {
            element: input,
            event: 'change',
            handler: onQuantityChange
          }
        ];
      };

      bindQuantityInput();

      /*
       * Quantity controls can be replaced dynamically
       * by the Shopify theme.
       */
      if (this._dlMutationObserver) {
        this._dlMutationObserver.disconnect();
      }

      this._dlMutationObserver =
        new MutationObserver(() => {
          bindQuantityInput();
        });

      this._dlMutationObserver.observe(
        document.body,
        {
          childList: true,
          subtree: true
        }
      );
    }

    removeQuantityListeners() {
      this._dlQuantityListeners.forEach(
        ({ element, event, handler }) => {
          element.removeEventListener(
            event,
            handler
          );
        }
      );

      this._dlQuantityListeners = [];
      this._dlQuantityInput = null;
    }

    /* ============================================================
       UK INVENTORY CACHE
    ============================================================ */

    getUkStockCacheKey(variantId) {
      return String(variantId);
    }

    getCachedUkStock(variantId) {
      const key =
        this.getUkStockCacheKey(variantId);

      const cached =
        window.__dlUkStockCache[key];

      if (!cached) {
        return null;
      }

      /*
       * Cache lifetime = 30 seconds.
       */
      const age =
        Date.now() - cached.timestamp;

      if (age > 30000) {
        delete window.__dlUkStockCache[key];
        return null;
      }

      return cached.quantity;
    }

    setCachedUkStock(variantId, quantity) {
      const key =
        this.getUkStockCacheKey(variantId);

      window.__dlUkStockCache[key] = {
        quantity: Number(quantity) || 0,
        timestamp: Date.now()
      };
    }

    clearUkStockCache(variantId) {
      const key =
        this.getUkStockCacheKey(variantId);

      delete window.__dlUkStockCache[key];
    }

    /* ============================================================
       UK INVENTORY - MAIN METHOD
    ============================================================ */

    fetchUkWarehouseStock(
      variantId,
      options = {}
    ) {
      const forceRefresh =
        options.forceRefresh === true;

      if (!variantId) {
        return Promise.reject(
          new Error(
            'Missing Shopify variant ID.'
          )
        );
      }

      if (!forceRefresh) {
        const cached =
          this.getCachedUkStock(variantId);

        if (cached !== null) {
          console.log(
            '[Dulora Warehouse] UK stock from cache:',
            cached
          );

          return Promise.resolve(cached);
        }
      }

      /*
       * Preferred method:
       *
       * A server-side/app-proxy endpoint should return
       * inventory specifically for:
       *
       * UK - Warehouse
       *
       * Example:
       *
       * window.DULORA_UK_STOCK_ENDPOINT =
       * '/apps/dulora-inventory';
       */
      if (
        typeof window.DULORA_UK_STOCK_ENDPOINT ===
        'string' &&
        window.DULORA_UK_STOCK_ENDPOINT.trim()
      ) {
        return this.fetchUkStockFromEndpoint(
          variantId
        );
      }

      /*
       * Temporary Storefront API fallback.
       *
       * Your current test shows that this does NOT return
       * UK - Warehouse, so this should be treated as a
       * fallback only.
       */
      return this.fetchUkStockFromStorefront(
        variantId
      );
    }

    /* ============================================================
       UK INVENTORY - SERVER / APP PROXY
    ============================================================ */

    fetchUkStockFromEndpoint(variantId) {
      const endpoint =
        window.DULORA_UK_STOCK_ENDPOINT;

      const url =
        `${endpoint}?variant_id=${encodeURIComponent(variantId)}`;

      console.log(
        '[Dulora Warehouse] Fetching UK stock from endpoint:',
        url
      );

      return fetch(url, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(
              `UK inventory endpoint returned HTTP ${response.status}`
            );
          }

          return response.json();
        })
        .then((json) => {
          /*
           * Accept common response formats.
           *
           * Preferred:
           * { quantity: 10 }
           *
           * Also supports:
           * { available_quantity: 10 }
           * { inventory_quantity: 10 }
           */
          const rawQuantity =
            json?.quantity ??
            json?.available_quantity ??
            json?.inventory_quantity;

          if (
            rawQuantity === undefined ||
            rawQuantity === null
          ) {
            throw new Error(
              'UK inventory endpoint did not return a quantity.'
            );
          }

          const quantity =
            Math.max(
              0,
              parseInt(rawQuantity, 10) || 0
            );

          this.setCachedUkStock(
            variantId,
            quantity
          );

          console.log(
            '[Dulora Warehouse] UK stock:',
            quantity
          );

          return quantity;
        })
        .catch((error) => {
          /*
           * IMPORTANT:
           *
           * Never cache API failures as zero.
           *
           * Zero means:
           * "UK warehouse has zero stock."
           *
           * An API error means:
           * "We don't know the UK stock."
           */
          console.error(
            '[Dulora Warehouse] UK inventory endpoint failed:',
            error
          );

          throw error;
        });
    }

    /* ============================================================
       UK INVENTORY - STOREFRONT API FALLBACK
    ============================================================ */

    fetchUkStockFromStorefront(variantId) {
      const query = `
        query variantAvailability($ids: [ID!]!) {
          nodes(ids: $ids) {
            ... on ProductVariant {
              storeAvailability(first: 50) {
                edges {
                  node {
                    quantityAvailable
                    location {
                      name
                    }
                  }
                }
              }
            }
          }
        }
      `;

      const gid =
        'gid://shopify/ProductVariant/' +
        variantId;

      const storefrontToken =
        (
          window.DULORA_STOREFRONT_TOKEN ||
          ''
        )
          .replace(/[^\x00-\x7F]/g, '')
          .trim();

      const headers = {
        'Content-Type':
          'application/json'
      };

      if (storefrontToken) {
        headers[
          'X-Shopify-Storefront-Access-Token'
        ] = storefrontToken;
      }

      return fetch(
        '/api/2024-10/graphql.json',
        {
          method: 'POST',
          headers,
          body: JSON.stringify({
            query,
            variables: {
              ids: [gid]
            }
          })
        }
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(
              `Storefront API HTTP ${response.status}`
            );
          }

          return response.json();
        })
        .then((json) => {
          /*
           * GraphQL errors must NOT be treated as
           * zero inventory.
           */
          if (
            Array.isArray(json?.errors) &&
            json.errors.length
          ) {
            const message =
              json.errors
                .map((error) =>
                  error.message
                )
                .join('; ');

            throw new Error(
              message
            );
          }

          const edges =
            json?.data
              ?.nodes?.[0]
              ?.storeAvailability
              ?.edges || [];

          console.log(
            '[Dulora Warehouse] Storefront availability:',
            edges
          );

          /*
           * IMPORTANT:
           *
           * Match the exact warehouse.
           *
           * Do NOT use:
           * name.includes('uk')
           *
           * because another UK-related location could
           * accidentally be selected.
           */
          const targetLocation =
            this._dlUkLocationName
              .trim()
              .toLowerCase();

          const ukEdge =
            edges.find((edge) => {
              const locationName =
                (
                  edge?.node
                    ?.location?.name ||
                  ''
                )
                  .trim()
                  .toLowerCase();

              return (
                locationName ===
                targetLocation
              );
            });

          if (!ukEdge) {
            throw new Error(
              `UK warehouse "${this._dlUkLocationName}" was not returned by Storefront API.`
            );
          }

          const quantity =
            Math.max(
              0,
              parseInt(
                ukEdge.node.quantityAvailable,
                10
              ) || 0
            );

          this.setCachedUkStock(
            variantId,
            quantity
          );

          console.log(
            '[Dulora Warehouse] UK stock:',
            quantity
          );

          return quantity;
        })
        .catch((error) => {
          /*
           * IMPORTANT:
           *
           * Do NOT write:
           * window.__dlUkStockCache[id] = 0
           *
           * when the request fails.
           */
          console.error(
            '[Dulora Warehouse] Storefront UK inventory failed:',
            error
          );

          throw error;
        });
    }

    /* ============================================================
       TIMEZONE / CUTOFF
    ============================================================ */

    getZonedDateParts(date, timeZone) {
      const formatter =
        new Intl.DateTimeFormat(
          'en-US',
          {
            timeZone,
            hour12: false,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            weekday: 'short'
          }
        );

      const parts = {};

      formatter
        .formatToParts(date)
        .forEach((part) => {
          parts[part.type] =
            part.value;
        });

      let hour =
        parseInt(
          parts.hour,
          10
        );

      /*
       * Some browsers return 24 for midnight.
       */
      if (hour === 24) {
        hour = 0;
      }

      return {
        year: parseInt(parts.year, 10),
        month: parseInt(parts.month, 10),
        day: parseInt(parts.day, 10),
        hour,
        minute: parseInt(parts.minute, 10),
        second: parseInt(parts.second, 10),
        weekday: parts.weekday
      };
    }

    getTimezoneOffsetMs(
      date,
      timeZone
    ) {
      const parts =
        this.getZonedDateParts(
          date,
          timeZone
        );

      const asUTC =
        Date.UTC(
          parts.year,
          parts.month - 1,
          parts.day,
          parts.hour,
          parts.minute,
          parts.second
        );

      return (
        asUTC -
        date.getTime()
      );
    }

    zonedTimeToUtc(
      year,
      month,
      day,
      hour,
      minute,
      second,
      timeZone
    ) {
      let utcTimestamp =
        Date.UTC(
          year,
          month - 1,
          day,
          hour,
          minute,
          second
        );

      /*
       * Resolve timezone offset.
       *
       * Cutoffs are 10:00 / 14:00 and do not occur
       * during DST transition hours, so this is stable.
       */
      for (let i = 0; i < 3; i++) {
        const offset =
          this.getTimezoneOffsetMs(
            new Date(utcTimestamp),
            timeZone
          );

        utcTimestamp =
          Date.UTC(
            year,
            month - 1,
            day,
            hour,
            minute,
            second
          ) - offset;
      }

      return new Date(
        utcTimestamp
      );
    }

    addCalendarDays(
      year,
      month,
      day,
      amount
    ) {
      const date =
        new Date(
          Date.UTC(
            year,
            month - 1,
            day
          )
        );

      date.setUTCDate(
        date.getUTCDate() +
        amount
      );

      return {
        year:
          date.getUTCFullYear(),

        month:
          date.getUTCMonth() + 1,

        day:
          date.getUTCDate()
      };
    }

    msUntilNextCutoff(
      timeZone,
      cutoffHour
    ) {
      const now =
        new Date();

      const current =
        this.getZonedDateParts(
          now,
          timeZone
        );

      const weekdayNames = [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
      ];

      const fullDayNames = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      ];

      const currentWeekdayIndex =
        weekdayNames.indexOf(
          current.weekday
        );

      const isWeekend =
        current.weekday === 'Sat' ||
        current.weekday === 'Sun';

      /*
       * Before today's cutoff on a weekday:
       * dispatch today.
       */
      if (
        !isWeekend &&
        current.hour < cutoffHour
      ) {
        const target =
          this.zonedTimeToUtc(
            current.year,
            current.month,
            current.day,
            cutoffHour,
            0,
            0,
            timeZone
          );

        return {
          msRemaining:
            Math.max(
              0,
              target.getTime() -
                now.getTime()
            ),

          dispatchLabel:
            'today'
        };
      }

      /*
       * After cutoff or weekend:
       * find the next weekday.
       */
      let daysToAdd = 1;

      while (true) {
        const targetDate =
          this.addCalendarDays(
            current.year,
            current.month,
            current.day,
            daysToAdd
          );

        const targetUTC =
          new Date(
            Date.UTC(
              targetDate.year,
              targetDate.month - 1,
              targetDate.day
            )
          );

        const targetWeekday =
          targetUTC.getUTCDay();

        if (
          targetWeekday !== 0 &&
          targetWeekday !== 6
        ) {
          const target =
            this.zonedTimeToUtc(
              targetDate.year,
              targetDate.month,
              targetDate.day,
              cutoffHour,
              0,
              0,
              timeZone
            );

          return {
            msRemaining:
              Math.max(
                0,
                target.getTime() -
                  now.getTime()
              ),

            dispatchLabel:
              fullDayNames[
                targetWeekday
              ]
          };
        }

        daysToAdd++;
      }
    }

    formatCountdown(ms) {
      if (ms <= 0) {
        return '0 hrs 0 min';
      }

      const totalMinutes =
        Math.floor(
          ms / 60000
        );

      const hours =
        Math.floor(
          totalMinutes / 60
        );

      const minutes =
        totalMinutes % 60;

      return `${hours} hrs ${minutes} min`;
    }

    renderWarehouseCountdown(
      timeZone,
      cutoffHour
    ) {
      const result =
        this.msUntilNextCutoff(
          timeZone,
          cutoffHour
        );

      const html =
        `Order within <span class="time-left">${this.formatCountdown(result.msRemaining)}</span> to dispatch ${result.dispatchLabel}`;

      this._dlCountdownEls()
        .forEach((element) => {
          element.innerHTML =
            html;
        });
    }

    /* ============================================================
       APPLY SYDNEY
    ============================================================ */

    applyAuWarehouse() {
      if (
        this._dlTooltipEl &&
        !this._dlTooltipOverridden
      ) {
        this._dlTooltipEl.textContent =
          this._dlAuTooltip;
      }

      this.renderWarehouseCountdown(
        this._dlAuTimezone,
        this._dlAuCutoffHour
      );
    }

    /* ============================================================
       APPLY UK
    ============================================================ */

    applyUkWarehouse() {
      if (
        this._dlTooltipEl &&
        !this._dlTooltipOverridden
      ) {
        this._dlTooltipEl.textContent =
          this._dlUkTooltip;
      }

      this.renderWarehouseCountdown(
        this._dlUkTimezone,
        this._dlUkCutoffHour
      );
    }

    /* ============================================================
       WAREHOUSE DECISION
    ============================================================ */

    evaluateWarehouseDispatch(
      options = {}
    ) {
      /*
       * Static storefronts always use Sydney.
       */
      if (
        this._dlMode === 'static'
      ) {
        this.applyAuWarehouse();
        return;
      }

      const variantId =
        this._dlVariantId;

      if (!variantId) {
        console.warn(
          '[Dulora Warehouse] No variant ID. Falling back to Sydney.'
        );

        this.applyAuWarehouse();
        return;
      }

      const requestId =
        ++this._dlWarehouseRequestId;

      const selectedQuantity =
        this.getSelectedQuantity();

      console.log(
        '[Dulora Warehouse] Checking warehouse:',
        {
          variantId,
          selectedQuantity,
          location:
            this._dlUkLocationName
        }
      );

      this.fetchUkWarehouseStock(
        variantId,
        {
          forceRefresh:
            options.forceRefresh === true
        }
      )
        .then((ukStock) => {
          /*
           * Ignore an old response if the customer changed
           * variant/quantity while the request was running.
           */
          if (
            requestId !==
            this._dlWarehouseRequestId
          ) {
            return;
          }

          const currentQuantity =
            this.getSelectedQuantity();

          console.log(
            '[Dulora Warehouse] Decision:',
            {
              ukStock,
              selectedQuantity:
                currentQuantity,
              ukLocation:
                this._dlUkLocationName
            }
          );

          /*
           * UK if:
           *
           * selected quantity <= UK stock
           *
           * and UK stock is greater than zero.
           */
          if (
            ukStock > 0 &&
            currentQuantity <= ukStock
          ) {
            this.applyUkWarehouse();

            console.log(
              '[Dulora Warehouse] Result: UK warehouse'
            );
          } else {
            this.applyAuWarehouse();

            console.log(
              '[Dulora Warehouse] Result: Sydney warehouse'
            );
          }
        })
        .catch((error) => {
          /*
           * If UK inventory cannot be obtained,
           * safely fall back to Sydney.
           */
          if (
            requestId !==
            this._dlWarehouseRequestId
          ) {
            return;
          }

          console.warn(
            '[Dulora Warehouse] UK inventory unavailable. Falling back to Sydney.',
            error
          );

          this.applyAuWarehouse();
        });
    }

    /* ============================================================
       VARIANT CHANGE
    ============================================================ */

    handleVariantChange(evt) {
      if (
        evt.detail &&
        evt.detail.variant
      ) {
        const variant =
          evt.detail.variant;

        const inventory =
          this.variantInventory.find(
            (v) =>
              String(v.id) ===
              String(variant.id)
          );

        if (inventory) {
          this.updateInventory(
            inventory.inventory_quantity,
            inventory.available
          );

          this.customUpdateStock(
            inventory
          );
        }

        /*
         * Update current variant.
         */
        this._dlVariantId =
          variant.id;

        this.dataset.variantId =
          variant.id;

        /*
         * Cancel any pending warehouse request.
         */
        this._dlWarehouseRequestId++;

        /*
         * A variant change should request the latest
         * UK warehouse stock.
         */
        this.clearUkStockCache(
          variant.id
        );

        console.log(
          '[Dulora Warehouse] Variant changed:',
          variant.id
        );

        this.evaluateWarehouseDispatch({
          forceRefresh: true
        });
      } else {
        this.updateInventory(
          0,
          false
        );

        this.hidden = true;
      }
    }

    /* ============================================================
       EXISTING INVENTORY LOGIC
    ============================================================ */

    getVariantInventory() {
      const dataEl =
        this.querySelector(
          '[type="application/json"]'
        );

      return (
        this.variantInventory ||
        (
          dataEl
            ? JSON.parse(
                dataEl.textContent
              )
            : []
        )
      );
    }

    updateInventory(
      count,
      available
    ) {
      let inventoryLevel;

      if (count <= 0) {
        inventoryLevel =
          available
            ? 'in_stock'
            : 'none';
      } else if (
        count <=
        parseInt(
          this.dataset.thresholdVeryLow,
          10
        )
      ) {
        inventoryLevel =
          'very_low';
      } else if (
        count <=
        parseInt(
          this.dataset.thresholdLow,
          10
        )
      ) {
        inventoryLevel =
          'low';
      } else {
        inventoryLevel =
          'normal';
      }

      if (
        this.dataset.showNotice ===
          'always' ||
        (
          this.dataset.showNotice ===
            'low' &&
          inventoryLevel.includes(
            'low'
          )
        )
      ) {
        this.hidden = false;

        this.setAttribute(
          'data-inventory-level',
          inventoryLevel
        );

        if (
          inventoryLevel !==
            'in_stock' &&
          (
            this.dataset.showCount ===
              'always' ||
            (
              this.dataset.showCount ===
                'low' &&
              inventoryLevel.includes(
                'low'
              )
            )
          )
        ) {
          if (count > 100) {
            this.inventoryNotice.innerText =
              theme.strings.onlyXLeft.replace(
                '[quantity]',
                '100+'
              );
          } else if (count > 50) {
            this.inventoryNotice.innerText =
              theme.strings.onlyXLeft.replace(
                '[quantity]',
                '50+'
              );
          } else {
            this.inventoryNotice.innerText =
              theme.strings.onlyXLeft.replace(
                '[quantity]',
                count
              );
          }
        } else if (
          inventoryLevel.includes(
            'low'
          )
        ) {
          this.inventoryNotice.innerText =
            theme.strings.lowStock;
        } else if (
          inventoryLevel ===
            'normal' ||
          inventoryLevel ===
            'in_stock'
        ) {
          this.inventoryNotice.innerText =
            theme.strings.inStock;
        } else if (
          inventoryLevel ===
          'none'
        ) {
          this.inventoryNotice.innerText =
            theme.strings.noStock;
        }

        if (this.urgencyMessage) {
          if (
            inventoryLevel ===
            'very_low'
          ) {
            this.urgencyMessage.innerHTML =
              this.dataset.textVeryLow;
          } else if (
            inventoryLevel ===
            'low'
          ) {
            this.urgencyMessage.innerHTML =
              this.dataset.textLow;
          } else if (
            inventoryLevel ===
                'normal' ||
            inventoryLevel ===
                'in_stock'
          ) {
            this.urgencyMessage.innerHTML =
              this.dataset.textNormal;
          } else if (
            inventoryLevel ===
            'none'
          ) {
            this.urgencyMessage.innerHTML =
              this.dataset.textNoStock;
          }
        }

        if (this.indicatorBar) {
          this.indicatorBar.hidden =
            false;

          const scale =
            parseInt(
              this.dataset.scale,
              10
            ) || 1;

          const newWidth =
            (
              count >= scale ||
              inventoryLevel ===
                'in_stock'
            )
              ? 100
              : (
                  100 /
                  scale *
                  count
                ).toFixed(1);

          this.indicatorBar
            .querySelector('span')
            .style.width =
            `${newWidth}%`;
        }
      } else {
        this.hidden = true;
      }
    }

    customUpdateStock(
      availableVariants
    ) {
      let availHTML = '';

      const hideCheckoutBtn =
        () =>
          document
            .querySelectorAll(
              '.dynamic_checkout_btn'
            )
            .forEach((el) =>
              el.classList.add(
                'hidden'
              )
            );

      const showCheckoutBtn =
        () =>
          document
            .querySelectorAll(
              '.dynamic_checkout_btn'
            )
            .forEach((el) =>
              el.classList.remove(
                'hidden'
              )
            );

      const hideShippingTime =
        () => {
          const shippingEl =
            document.getElementById(
              'shipping-time'
            );

          if (
            shippingEl?.parentElement
          ) {
            shippingEl.parentElement.classList.add(
              'hidden'
            );
          }
        };

      const showShippingTime =
        () => {
          const shippingEl =
            document.getElementById(
              'shipping-time'
            );

          if (
            shippingEl?.parentElement
          ) {
            shippingEl.parentElement.classList.remove(
              'hidden'
            );
          }
        };

      if (availableVariants) {
        if (
          availableVariants.inventory_management ===
          'shopify'
        ) {
          if (
            availableVariants.inventory_quantity <
              10 &&
            availableVariants.inventory_quantity >
              0
          ) {
            availHTML = ' ';
          } else if (
            availableVariants.inventory_quantity <=
              0 &&
            availableVariants.inventory_policy ===
              'continue'
          ) {
            availHTML =
              availableVariants.next_incoming_date
                ? `<span>Restocking ${availableVariants.next_incoming_date}</span>`
                : '<span></span>';
          } else if (
            availableVariants.inventory_quantity <=
              0 &&
            availableVariants.inventory_policy ===
              'deny'
          ) {
            hideShippingTime();

            if (
              availableVariants.next_incoming_date
            ) {
              hideCheckoutBtn();

              availHTML =
                `<span>Restocking ${availableVariants.next_incoming_date}</span>`;
            } else {
              availHTML =
                '<span> </span>';
            }
          } else {
            if (
              availableVariants.available ===
              false
            ) {
              hideCheckoutBtn();
              hideShippingTime();
            } else {
              showCheckoutBtn();
              showShippingTime();
            }
          }
        } else {
          if (
            availableVariants.available ===
            false
          ) {
            availHTML = ' ';
          } else {
            showCheckoutBtn();
            availHTML = ' ';
          }
        }
      }

      document
        .querySelectorAll(
          '.backorder_date .change_content'
        )
        .forEach((el) => {
          el.setAttribute(
            'data-max',
            availableVariants.inventory_quantity
          );

          el.innerHTML =
            availHTML;
        });
    }

    /* ============================================================
       CLEANUP
    ============================================================ */

    disconnectedCallback() {
      clearTimeout(
        this._dlDebounceTimer
      );

      clearInterval(
        this._dlCountdownInterval
      );

      this.removeQuantityListeners();

      if (this._dlMutationObserver) {
        this._dlMutationObserver.disconnect();
      }
    }
  }

  customElements.define(
    'product-inventory',
    ProductInventory
  );
}